import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "amenities",
    object: "amenity",
    header: [

      { text: "Nombre", value: "name" },
      { text: "Imagen de Icono", value: "icon_picture", sortable: false },
      { text: "Descripción", value: "description" },
      { text: "Acciones", value: "actions", sortable: false }
    ]
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions
  },
  getters: {
    ...genericStore.getters
  }
};
